import { createApp } from "vue";

window.axios = require('axios')
window.lodash = require('lodash')

import YoutubeWrapper from './Components/YoutubeWrapper.vue'
import BgVideoWrapper from './Components/BgVideoWrapper.vue'

const app = createApp({})

app.component('ef2-youtube-wrapper', YoutubeWrapper)
app.component('bg-video-wrapper', BgVideoWrapper)

app.mount('#page-wrapper')